export const visualOptions = {
    marginTop: {
        type: 'number',
        label: 'Margin (top)',
        default: 20,
        group: 'artboard',
    },
    marginRight: {
        type: 'number',
        label: 'Margin (right)',
        default: 20,
        group: 'artboard',
    },
    marginBottom: {
        type: 'number',
        label: 'Margin (bottom)',
        default: 40,
        group: 'artboard',
    },
    marginLeft: {
        type: 'number',
        label: 'Margin (left)',
        default: 40,
        group: 'artboard',
    },
    color: {
        type: 'color',
        label: 'Color',
        default: '#69b3a2',
        group: 'chart',
    },
    bins: {
        type: 'number',
        label: 'Bins',
        default: 20,
        group: 'chart',
    },
    padding: {
        type: 'number',
        label: 'Padding',
        default: 1,
        group: 'chart',
    },
}
